import { Component } from 'react';
import styled from 'styled-components';
import { fontSize, path } from '../../../../../common/css/setting/variable';
import NumberHelper from '../../../../../common/helper/NumberHelper';

interface Props {
  readonly taxIncludedPrice: number;
}

const Wrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-top: 8px;
  font-size: ${fontSize.px12};
  color: ${props => props.theme.news.palette.text_base_common};
`;

const Text = styled.p`
  display: flex;
  align-items: center;
  line-height: 20px;
`;

const PayPay = styled.span`
  position: relative;
  display: inline-block;
  height: 20px;
  padding-left: 22px;
  margin-right: 2px;
  font-size: ${fontSize.px12};
  font-weight: bold;
  background-image: url(${path.img_icon_PayPay}); /* PayPayアイコン */
  background-repeat: no-repeat;
  background-size: 20px auto;
`;

export const Price = styled.p`
  font-size: ${fontSize.px12};
`;

export const PriceNumber = styled.em`
  font-size: ${fontSize.px14};
  font-weight: bold;
`;

export default class NewsFeedPrice extends Component<Props> {
  /**
   *
   */
  public render() {
    return (
      <Wrapper>
        <Text>
          <PayPay>PayPay残高</PayPay>
          使えます
        </Text>
        <Price>
          税込
          <PriceNumber>{NumberHelper.convertCommaSeparated(this.props.taxIncludedPrice)}</PriceNumber>円
        </Price>
      </Wrapper>
    );
  }
}
